<template>
  <Login></Login>
    <div class="body container">
  <img src="../assets/images/amfer-vsnikromant.png" alt="img">
  <div class=" container bar circle-container">
    <div class="circle-container bar">
    <div class="bar">
         <div class="loader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
         </div>
    </div>
    </div>
    </div>
</div>

</template>    


<script>
import Login from './login.vue';
export default {
  name: "shobsho",
  components:{
    Login
  }
  }
</script>

<style scoped>
.body {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
 /*  margin: 0; */
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: black; */
  background: linear-gradient(135deg, #1e2a3a 0%, #2d3e50 100%);
  overflow: hidden;
}

.container{
  position: relative;
  width: revert;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle-container{
  position: absolute;
  width: 100%;
  height: 100%;
  animation: rotate 20s linear infinite;
 
}

@keyframes rotate {
  from{transform: rotate(0deg);}
  to{transform: rotate(360deg);}
}

.loader,  .loader span {
  width: 10em;
  height: 10em;
  border: 0.25em solid white;
  font-size: 10px;
  border-radius: 1em;
  position: absolute;
  mix-blend-mode: screen;
}
.loader {
  background-color: gold;
  animation: rotating 2s linear infinite;
}
@keyframes rotating {
  to {
    transform: rotate(1turn);
  }
}
.loader span {
  animation: de-rotating 4s linear infinite;
}
@keyframes de-rotating {
  from, to{
    transform: rotate(0deg)
     scale(0.5);
  }
  50% {
    transform: rotate(-180deg)
    scale(1.2);
  }
}
.loader span:nth-child(1) {
  top: 5em;
  left: 5em;
  background-color: dodgerblue;
}
.loader span:nth-child(2) {
  top: -5em;
  left: 5em;
  background-color: hotpink;
}
.loader span:nth-child(3) {
  top: 5em;
  left: -5em;
  background-color: mediumpurple;
}
.loader span:nth-child(4) {
  top: -5em;
  left: -5em;
  background-color: limegreen;
}



.bar{
  position: absolute;
  width: 8px;
  height: 35px;
  background: #4a5f7f;
  border-radius: 4px;
  top: 0;
  left: 50%;
  transform-origin: center 170px;
  transition: background 0.3s ease;
}

.bar.active{ 
  background: linear-gradient(180deg,#ffa500, #ff8c00);
  box-shadow: 0 0 20px rgba(255, 165, 0, 0.08);
}
</style>